import { AppController } from "../AppController";
var ContactAddressPage = /** @class */ (function () {
    function ContactAddressPage(_appController) {
        this._appController = _appController;
    }
    Object.defineProperty(ContactAddressPage.prototype, "appController", {
        get: function () {
            return this._appController;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAddressPage.prototype, "organization", {
        get: function () {
            return this.appController.organization;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAddressPage.prototype, "availableLanguages", {
        get: function () {
            return this.appController.availableLanguages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAddressPage.prototype, "availableCountries", {
        get: function () {
            return this.appController.availableCountries;
        },
        enumerable: true,
        configurable: true
    });
    return ContactAddressPage;
}());
export { ContactAddressPage };
